function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 14.5H13.5",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 14.5H29.5",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 9.5V18.5C3.5 19.8261 4.02678 21.0979 4.96447 22.0355C5.90215 22.9732 7.17392 23.5 8.5 23.5C9.82608 23.5 11.0979 22.9732 12.0355 22.0355C12.9732 21.0979 13.5 19.8261 13.5 18.5V9.5H3.5Z",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 9.5V18.5C19.5 19.8261 20.0268 21.0979 20.9645 22.0355C21.9021 22.9732 23.1739 23.5 24.5 23.5C25.8261 23.5 27.0979 22.9732 28.0355 22.0355C28.9732 21.0979 29.5 19.8261 29.5 18.5V9.5H19.5Z",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 23.5V31.5",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 31.5H12.5",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 1.5V4.5",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M10.843 3.84302L12.964 5.96402",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1569 3.84302L20.0359 5.96402",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5 23.5V31.5",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 31.5H28.5",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

function SvgCheerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheerIcon);
export default __webpack_public_path__ + "static/media/cheer-icon.ef681837.svg";
export { ForwardRef as ReactComponent };